import { useMemo, type PropsWithChildren } from "react";
import { SplitFactoryProvider } from "@splitsoftware/splitio-react";
import type { FeatureManagementAttributes, FeatureManagementConfig } from "./types";
import { buildSplitConfig } from "./config";

interface FeatureManagementProviderProps extends PropsWithChildren {
  config: FeatureManagementConfig;
  attributes?: FeatureManagementAttributes;
}

export function FeatureManagementProvider({
  children,
  config,
  attributes,
}: FeatureManagementProviderProps) {
  const splitConfig = useMemo(() => buildSplitConfig(config), [config]);
  const splitFactoryKey = `${config.useLocalhost}:${config.sdkKey}:${config.userKey}`;

  return (
    <SplitFactoryProvider
      key={splitFactoryKey}
      config={splitConfig}
      attributes={attributes}
    >
      {children}
    </SplitFactoryProvider>
  );
}
